import chroma from 'chroma-js'

import { UIState } from './types'

const PRIMARY_COLOR = '#1677ff'

const initialUIState: UIState = {
    assets: {
        logo: 'https://expert4-application.autralis.com/autralis-logo.png',
        logoLight: 'https://expert4-application.autralis.com/autralis-logo-light.png',
    },
    colors: {
        primary: PRIMARY_COLOR,
        primaryBackground: chroma.mix(PRIMARY_COLOR, 'white', 0.2).css(),
        primaryBackgroundLight: chroma.mix(PRIMARY_COLOR, 'white', 0.92).css(),
        error: 'red',
        success: 'green',
        subtle: '#C6C6C6',
    },
    sensitiveContentVisible: true,
    apps: [],
    appSettings: null,
    loadingAppSettings: false,
}

export default initialUIState
